<template>
	<div class="wrap">
		<myHead></myHead>
		<div class="wrap_body">
			<div class="center">
				<div class="ucenter_main" v-loading="isLoading">
					<ucMenu num="1"></ucMenu>
					<div class="right_con">
						<div class="upr">
							<div class="upr_header">
								<div class="prefix">
									<div class="title">货源盲盒</div>
									<div class="tips">
										<i class="el-icon-question"></i> {{ TIPS }}
									</div>
								</div>
								<div class="suffix">
									<el-button class="primary" @click="handlerCreateDialog()">创建策略</el-button>
								</div>
							</div>

							<div class="upr_table">
								<div class="upr_table_header">
									<div class="col col_index">ID</div>
									<div class="col col_status">状态</div>
									<div class="col col_shop">店铺名称</div>
									<div class="col col_copy_limit">每日数</div>
									<div class="col col_copy_limit">铺货中</div>
									<div class="col col_num_count">今日成功/失败</div>
									<div class="col col_copy_limit">铺货成功</div>
									<div class="col col_event_cate">执行类目(PDD)</div>
									<div class="col col_event_cate">执行类目(线下)</div>
									<div class="col col_inc_price">加价</div>
									<div class="col col_deliver">发货策略</div>
									<div class="col col_freight">运费模板</div>
									<div class="col col_operation">操作</div>
								</div>
								<div class="upr_table_line" v-for="item in list" :key="item.id">
									<div class="col col_index">
										<div class="col_index_content">
											{{ item.id }}
										</div>
									</div>
									<div class="col col_status">
										<div class="col_status_content">
											<el-switch
												v-model="item.status"
												active-color="#1251e7"
												inactive-color="#dddddd"
												:active-value="1"
												:inactive-value="0"
												@change="handlerSwitchChange(item, $event)"
											></el-switch>
										</div>
									</div>
									<div class="col col_shop">
										<div class="col_shop_content" v-if="item.dd_shop">
											<span>{{ item.dd_shop.shop_name }}</span>
											<el-tag type="danger" size="mini" v-if="item.dd_shop.dd_resources_state!=1">素材库已满</el-tag>
											<el-tag type="warning" size="mini" v-if="item.dd_shop.dd_puhuo_limited==1">每日铺货达上限</el-tag>
											<el-tag type="danger" size="mini" v-if="item.error">{{ item.error }}</el-tag>
										</div>
										<div class="col_shop_content" v-else>
											<el-tag type="danger" size="mini">店铺已删除</el-tag>
										</div>
									</div>
									<div class="col col_copy_limit">
										<div class="col_copy_limit_content">
											{{ item.copy_limit }}
										</div>
									</div>
									<div class="col col_copy_limit">
										<div class="col_copy_limit_content">
											{{ item.waiting }}
										</div>
									</div>
									<div class="col col_num_count">
										<div class="col_copy_limit_content">
											{{ item.daily_success }}/{{ item.daily_fail }}
										</div>
									</div>
									<div class="col col_copy_limit">
										<div class="col_copy_limit_content">
											{{ item.success_num }}
										</div>
									</div>
									<div class="col col_event_cate">
										<div class="col_event_cate_content">
											{{ item.cate_shop_names.join('/') }}
										</div>
									</div>
									<div class="col col_event_cate">
										<div class="col_event_cate_content">
											{{ item.cate_shop_names2.join('/') }}
										</div>
									</div>
									<div class="col col_inc_price">
										<div class="col_inc_price_content">
											{{ '原价*' + item.inc_price_percent + '%' + (item.price_type == 1 ? '+' : '-') + item.inc_price + '元' }}
										</div>
									</div>
									<div class="col col_deliver">
										<div class="col_deliver_content">
											{{ item.deliver_name }}
										</div>
									</div>
									<div class="col col_freight">
										<div class="col_freight_content">
											{{ item.freight_template_name }}
										</div>
									</div>
									<div class="col_operation">
										<div class="col_operation_content">
											<el-button class="primary" @click="handlerCreateDialog(item)">编辑</el-button>
											<el-popconfirm
												title="删除后无法恢复，是否继续？"
												@confirm="handlerDelete(item)"
											>
												<template #reference>
													<el-button class="error">删除</el-button>
												</template>
											</el-popconfirm>
										</div>
									</div>
								</div>
							</div>
							<div class="upr_pagination">
								<basePagination
									:size="pagination.size"
									:current="pagination.current"
									:total="pagination.total"
									@change="handlerChange"
								></basePagination>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<baseDialog
			:title="default_form.title"
			width="800px"
			:visible.sync="default_form.visible"
			@close="default_form.visible = false"
		>
			<formComponent
				ref="formComponent"
				:enums="enums"
				@confirm="handlerDefaultFormConfirm"
				@cancel="handlerDefaultFormCancel"
				@bindSuccess="handleBindSuccess"
			></formComponent>
		</baseDialog>
		<myFoot></myFoot>
	</div>
</template>

<script lang="jsx">
import ucMenu from "@/components/ucenterMenu/ucmenu.vue";
import myFoot from "@/components/myFoot/myfoot.vue";
import myHead from "@/components/myHead/myhead.vue";
import basePagination from "@/components/basePagination/basePagination.vue";
import baseDialog from "@/components/baseDialog/baseDialog.vue"
import formComponent from "./form.vue"
import {mapActions} from "vuex";
import { Loading } from 'element-ui';

export default {
	data() {
		return {
			TIPS: '免责声明：本站货盘将铺货到您店铺草稿箱，请您审核后再上架商品，上架后的商品出现任何违规，均与本站无关，使用本站即默认本条约!',
			isLoading: false,
			pagination: {
				total: 0,
				size: 5,
				current: 1,
			},
			list: [],
			enums: {
				copy_limit: [],
				shop: [],
				deliver: [],
				cate_list: [],
				cate_list2: [],
				cate_list3:[]
			},
			default_form: {
				visible: false,
				title: '货源盲盒',
				payload: {
					cate_shop_ids: [],
					s_cate_shop_ids: [],
					lh_cate_shop_ids: []
				},
			},
		}
	},
	components: {
		baseDialog, formComponent,
		ucMenu, myFoot, myHead, basePagination,
	},
	async mounted() {
		let loadingInstance = Loading.service({ fullscreen: true });
		await this.opProductRandomEnums({
			data: {},
			success: (res) => {
				this.enums = Object.assign(this.enums, res.data)
				if(this.$refs.formComponent){
					this.$refs.formComponent.initAliCateSelected()
				}
				loadingInstance.close();
			}
		})
		this.getList(true)
	},
	methods: {
		...mapActions({
			opProductRandomList: "ucenter/opProductRandomList",
			opProductRandomDelete: "ucenter/opProductRandomDelete",
			opProductRandomAdd: "ucenter/opProductRandomAdd",
			opProductRandomUpdate: "ucenter/opProductRandomUpdate",
			opMallCateList: "ucenter/opMallCateList",
			opProductRandomEnums: "ucenter/opProductRandomEnums",
		}),
		handlerSwitchChange({id}, val) {
			this.opProductRandomUpdate({
				data: {
					id: id,
					status: val,
				},
				success: (res) => {
					if (res.code == 200) {
						this.$message({
							type: 'success',
							message: res.msg
						})

					} else {
						this.$message({
							type: 'error',
							message: res.msg
						})
					}
					this.changeDialogVisible('default_form', false);
					this.refresh(true)
				}
			})
		},
		refresh() {
			this.getList(true)
		},
		getList(reset = false) {
			if (reset) {
				// this.pagination.current = 1;
			}
			this.opProductRandomList({
				data: {
					page: this.pagination.current,
					limit: this.pagination.size,
				},
				success: (res) => {
					this.list = res.data.data.map(item => {
						return Object.assign(item, {})
					});
					this.pagination.current = res.data.current_page;
					this.pagination.total = res.data.total;
				}
			})
		},
		handlerChange(page) {
			this.pagination.current = page;
			this.getList();
		},
		handlerDelete({id}) {
			this.isLoading = true;
			this.opProductRandomDelete({
				data: {
					id: id
				},
				success: (res) => {
					this.isLoading = false;
					if (res.code == 200) {
						this.$message({
							type: 'success',
							message: res.msg
						})
					} else {
						this.$message({
							type: 'error',
							message: res.msg
						})
					}
					this.refresh(true)
				}
			})
		},
		/** 默认表单 */
		handlerCreateDialog(data = {}) {
			this.changeDialogVisible('default_form');
			this.$nextTick(() => {
				this.$refs.formComponent.detail = Object.assign({
					status: 1,
					copy_limit_id: 0,
					copy_limit: null,
					deliver_id: null,
					shop_id: null,
					freight_template_id: null,
					cate_shop_ids: [],
					s_cate_shop_ids: [],
					lh_cate_shop_ids: [],
					alibaba_deliver_type: 1,
					inc_price: null,
					inc_price_percent: 100,
					price_type: 1,
					open_inc_price_2: false,
					inc_price_2: 0,
					inc_price_percent_2: 110,
					price_type_2: 1,
					open_inc_price_3: false,
					inc_price_3: 0,
					inc_price_percent_3: 120,
					price_type_3: 1,
					maximum_per_order: 3,
					limit_per_buyer: 5,
					minimum_per_order: 1,
					stock_type: 10,
					default_stock: '',
					al_cate_1: [],
					al_cate_2: [],
					al_cate_3: []
				}, data);
				this.$refs.formComponent.syncFreightTemplate()
				this.$refs.formComponent.initAliCateSelected()
			})
		},
		handlerDefaultFormCancel() {
			this.changeDialogVisible('default_form', false);
		},
		handlerDefaultFormConfirm(param) {
			const func = param?.id > 0 ? this.opProductRandomUpdate : this.opProductRandomAdd;
			if(param.stock_type==10){
				param.default_stock = 0;
			}
			param.open_inc_price_2 = param.open_inc_price_2 ? 1 : 0;
			param.open_inc_price_3 = param.open_inc_price_3 ? 1 : 0;
			// if (!param.copy_limit_id) {
			// 	this.$message({message: '请选择复制数量', type: 'error',});
			// 	return;
			// }
			if (!param.copy_limit) {
				this.$message({message: '请输入复制数量', type: 'error',});
				return;
			}
			if (!param.inc_price_percent) {
				this.$message({message: '请输入加价百分比', type: 'error',});
				return;
			}
			if (!param.shop_id) {
				this.$message({message: '请选择关联店铺', type: 'error',});
				return;
			}
			if (!param.deliver_id) {
				this.$message({message: '请选择发货策略', type: 'error',});
				return;
			}
			if (!param.freight_template_id) {
				this.$message({message: '请选择运费模板', type: 'error',});
				return;
			}
			if (param.al_cate_1.length < 1 && param.s_cate_shop_ids.length < 1 && param.lh_cate_shop_ids.length < 1) {
				this.$message({message: '请选择盲盒分类', type: 'error',});
				return;
			}
			if (!param.puhuo_type) {
				this.$message({message: '请选择上架方式', type: 'error',});
				return;
			}

			// 兜底处理
			if (param.cate_shop_ids.length < 1) {
				param.cate_shop_ids = [''];
			}
			if (param.s_cate_shop_ids.length < 1) {
				param.s_cate_shop_ids = [''];
			}
			if (param.al_cate_1.length < 1) {
				param.al_cate_1 = [''];
			}
			if (param.al_cate_2.length < 1) {
				param.al_cate_2 = [''];
			}
			if (param.al_cate_3.length < 1) {
				param.al_cate_3 = [''];
			}
			console.log(3333,param)
			func({
				data: param,
				success: (res) => {
					if (res.code == 200) {
						this.$message({
							type: 'success',
							message: res.msg
						})
					} else {
						this.$message({
							type: 'error',
							message: res.msg
						})
					}
					this.changeDialogVisible('default_form', false);
					this.refresh(true)
				}
			})

		},
		/** Dialog操作 */
		changeDialogVisible(mode, visible = true) {
			console.log(mode, visible)
			this[mode].visible = visible;
			if (!visible) {
				this.resetDialogPayload(mode)
			}
		},
		resetDialogPayload(mode, _val = {}) {
			this.$set(this[mode], 'payload', _val)
		},
		handleBindSuccess(cate_shop_id){
			let enums = JSON.parse(JSON.stringify(this.enums));
			enums.cate_list2.map((item) => {
				if (item.id == cate_shop_id) {
					item.visible = 1;
				} 
				return item;
			})
			this.enums = enums
		}
	}
}
</script>

<style lang="less" scoped>
.wrap .wrap_body {
	display: flex;
	flex-direction: column;
}

.center {
	display: flex;
	flex: 1;
}

.ucenter_main {
	padding: 30px 0 40px;
	display: flex;
	justify-content: space-between;
	flex: 1;
}

.right_con {
	width: 980px;
	background: #fff;
}

.col_shop_content {
	width: 100%;
}

.col_shop_content span {
	display: block;
	width: 100%;
	white-space: unset;
	height: auto;
}

.col_shop_content span.el-tag {
	margin-bottom: 5px;
}

.upr {
	font-family: MicrosoftYaHei;
	padding: 36px 40px;

	&_header {
		display: flex;
		margin-bottom: 20px;
		align-items: center;
		justify-content: space-between;
		column-gap: 30px;

		.prefix {
			.title {
				font-size: 16px;
				font-weight: bold;
				color: #333333;
			}

			.tips {
				margin-top: 10px;
				font-size: 14px;
				line-height: 24px;
				color: #f0413e;
			}
		}

		.suffix {
			.el-button {
				width: 90px;
				height: 34px;
				border-radius: 4px;
				font-size: 12px;
				color: #ffffff;
				padding: 0;
				display: flex;
				justify-content: center;
				align-items: center;

				&.primary {
					border-color: #1966ff;
					background-color: #1966ff;
				}
			}
		}
	}

	&_table {
		width: 100%;

		.col {
			font-size: 12px;
			color: #666666;
			display: flex;
			justify-content: center;
			align-items: center;

			&_index {
				margin-left: 5px;
				width: 30px;

				&_content {

				}
			}

			&_status {
				text-align: center;
				margin-left: 5px;
				width: 60px;

				&_content {

				}
			}

			&_strategy {
				text-align: center;
				margin-left: 5px;
				width: 100px;

				&_content {

				}
			}

			&_shop {
				text-align: center;
				margin-left: 5px;
				width: 180px;

				&_content {
					line-height: 23px;
					//text-align: left;
				}
			}

			&_num_count {
				text-align: center;
				margin-left: 5px;
				width: 80px;

				&_content {

				}
			}

			&_copy_limit {
				text-align: center;
				margin-left: 5px;
				width: 80px;

				&_content {

				}
			}

			&_event_cate {
				text-align: center;
				margin-left: 5px;
				width: 90px;

				&_content {

				}
			}

			&_inc_price {
				text-align: center;
				margin-left: 5px;
				width: 180px;

				&_content {

				}
			}

			&_deliver {
				text-align: center;
				margin-left: 5px;
				width: 80px;

				&_content {

				}
			}

			&_freight {
				text-align: center;
				margin-left: 5px;
				width: 80px;

				&_content {

				}
			}

			&_operation {
				margin-left: 5px;
				width: 60px;

				&_content {
					display: flex;
					flex-wrap: wrap;
					column-gap: 10px;
					row-gap: 10px;
					justify-content: center;

					.el-button {
						font-size: 13px;
						line-height: 24px;
						border: unset;
						height: 14px;
						padding: 0;
						margin: 0;
						background: transparent;

						&.primary {
							color: #1966ff;
						}

						&.error {
							color: #f0413e;
						}
					}
				}
			}
		}

		&_header {
			padding: 15px 0 20px 0;
			display: flex;
			width: 100%;
			background-color: #f9f9f9;
		}

		&_line {
			display: flex;
			width: 100%;
			padding: 22px 0 28px 0;
			border-bottom: solid 1px #eeeeee;
		}
	}

	&_pagination {
		margin-top: 20px;
		display: flex;
		justify-content: flex-end;
	}
}
</style>